import axios from "axios";
import { getValidToken } from "../../utils/authUtils";

export const staffAttendanceApi = {
  createAttendance: async (attendance: any) => {
    try {
      const token = await getValidToken();
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}staff-members/staff-attendance/company`,
        { data: attendance },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating attendance:", error);
      throw error;
    }
  },
  updateAttendance: async (attendance: any) => {
    try {
      const token = await getValidToken();
      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}staff-members/staff-attendance/company`,
        { data: attendance },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating attendance:", error);
      throw error;
    }
  },

  getAttendanceByDate: async (date: string) => {
    try {
      const token = await getValidToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}staff-members/staff-attendance/company/${date}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data?.data;
    } catch (error) {
      console.error("Error fetching attendance by date:", error);
      throw error;
    }
  },
};
